import { jsx as c } from "@emotion/react/jsx-runtime";
import { b as s } from "../global-behaviour/global-behaviour.js";
import t from "@mui/material/Checkbox";
import { forwardRef as a } from "react";
const n = "Checkbox", p = ["onChange"], d = (e) => e.target.checked ? "checked" : "unchecked", h = a((e, o) => {
  const r = s(n, p, e, d);
  return /* @__PURE__ */ c(t, { ...r, inputRef: o });
});
h.displayName = "Checkbox";
export {
  h as C,
  d as a
};
